import React, { useState, useEffect } from 'react';
import { TextField, Button, Checkbox } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { getQueryVariable, getAccessRightsForPageID, client, checkValidSession, getToken, getAdminID, actionGetVFASPClient } from "../store/action/RemoteActionSupervisor";
import { resetTimout } from "./common/FirebaseSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";

let SERVERAPI_URL = process.env.REACT_APP_SERVER_URL_API;

const ClientModify = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [selectedClient, setSelectedClient] = useState({});
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isModifed, setIsModifed] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false); //Trigger page rendering
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    const handleChange = (e) => {
        resetTimout();
        if (pageAccessRights.WriteAccess !== ACCESSRIGHTSTYPE.Yes) {
            return;
        }
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "id_MailID":
                selectedClient.MailID = eventValue;
                break;
            case "id_ClientName":
                selectedClient.ClientName = eventValue;
                break;
            case "id_Address1":
                selectedClient.Address1 = eventValue;
                break;
            case "id_Address2":
                selectedClient.Address2 = eventValue;
                break;
            case "id_RepresentativeName":
                selectedClient.RepresentativeName = eventValue;
                break;
            case "id_RepresentativeMailID":
                selectedClient.RepresentativeMailID = eventValue;
                break;
            case "id_RepresentativePhoneNumber":
                selectedClient.RepresentativePhoneNumber = eventValue;
                break;
            case "id_UserLogin":
                selectedClient.IsUserLogin = (e.target.checked) ? 1 : 0;
                break;
            case "id_AdminLogin":
                selectedClient.IsAdminLogin = (e.target.checked) ? 1 : 0;
                break;
            case "id_UserPasswordExpiry":
                selectedClient.UserPasswordExpiry = eventValue.replace(/[^0-9]/g, "");
                break;
            case "id_AdminPasswordExpiry":
                selectedClient.AdminPasswordExpiry = eventValue.replace(/[^0-9]/g, "");
                break;
            case "id_IsAutoCancel":
                selectedClient.IsAutoCancel = (e.target.checked) ? 1 : 0;
                if (e.target.checked && parseInt(selectedClient.AutoCancelDays) === 0) {
                    selectedClient.AutoCancelDays = parseInt(selectedClient.AutoBuyBackDays) + 1;
                }
                break;
            case "id_AutoCancelDays":
                selectedClient.AutoCancelDays = eventValue.replace(/[^0-9]/g, "");
                break;
            default:
                console.log(e.target.name);
        }
        setChangeStatus(!changeStatus);
        setIsModifed(true);
        setIsSubmitSuccess(false);
    };

    const submitModifyClient = async () => {
        const regexEmail = /^[a-z0-9_.@]+$/i;
        if (!checkValidSession()) {
            return;
        }

        if (!isModifed) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (!selectedClient.MailID || !selectedClient.ClientName || !selectedClient.Address1 || !selectedClient.RepresentativeName || !selectedClient.RepresentativeMailID ||
            !selectedClient.RepresentativePhoneNumber || !selectedClient.UserPasswordExpiry || !selectedClient.AdminPasswordExpiry) {
            alert(getMultiLanguageMessage('msg_Incomplete_Input_Error', language));
            return;
        }
        if (!regexEmail.test(selectedClient.MailID) || !regexEmail.test(selectedClient.RepresentativeMailID)) {
            alert(getMultiLanguageMessage('msg_InvalidEMail_Error', language));
            return;
        }
        if (selectedClient.IsAutoCancel === 1 && parseInt(selectedClient.AutoCancelDays) <= parseInt(selectedClient.AutoBuyBackDays)) {
            alert(getMultiLanguageMessage('msg_InvalidAutoCancelDays_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            let requestBody = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: getAdminID(),
                ClientID: selectedClient.ClientID,
                MailID: selectedClient.MailID,
                Address1: selectedClient.Address1,
                Address2: selectedClient.Address2,
                ClientName: selectedClient.ClientName,
                IsActive: selectedClient.IsActive,
                RepresentativeName: selectedClient.RepresentativeName,
                RepresentativeMailID: selectedClient.RepresentativeMailID,
                RepresentativePhoneNumber: selectedClient.RepresentativePhoneNumber,
                AutoBuyBackDays: selectedClient.AutoBuyBackDays
            };
            setIsButtonClicked(true);
            if (!checkValidSession()) {
                return;
            }

            await client(getToken()).put(`${SERVERAPI_URL}/vfaspclient/update`, requestBody).then((response) => {
                if (response.status == 200) {
                    setIsSubmitSuccess(true);
                    setIsModifed(false);
                } else {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                }
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
            });
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.client?.ClientID?.length > 0) {
            setSelectedClient(props?.client);
        }
    }, [props.client]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.Vfasp);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            let cientId = getQueryVariable(window.location.search, "CID");
            if (cientId && cientId.length > 0 && accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
                props.actionGetVFASPClient(cientId);
            } else {
                alert('Invalid Selection');
            }
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((selectedClient?.ClientID?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-ClientModify')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ClientID')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>{selectedClient.ClientID}</td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('MailID')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_MailID" name="id_MailID" sx={{ width: '50ch' }} value={selectedClient.MailID} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ClientName')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_ClientName" name="id_ClientName" sx={{ width: '50ch' }} value={selectedClient.ClientName} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Address1')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_Address1" name="id_Address1" value={selectedClient.Address1} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Address2')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_Address2" name="id_Address2" value={selectedClient.Address2} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('RepresentativeName')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_RepresentativeName" name="id_RepresentativeName" sx={{ width: '50ch' }} value={selectedClient.RepresentativeName} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('RepresentativeMailID')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_RepresentativeMailID" name="id_RepresentativeMailID" sx={{ width: '50ch' }} value={selectedClient.RepresentativeMailID} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('RepresentativePhoneNumber')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_RepresentativePhoneNumber" name="id_RepresentativePhoneNumber" sx={{ width: '50ch' }} value={selectedClient.RepresentativePhoneNumber} onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('AutoBuyBackDays')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_AutoBuyBackDays" name="id_AutoBuyBackDays" sx={{ width: '10ch' }} value={selectedClient.AutoBuyBackDays} disabled={true} />
                                        &nbsp;{translate('Days')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isSubmitSuccess &&
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <div className="gaps-2x d-sm-none" />
                                <span className="color-success">
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                </span>
                            </div>
                        }

                        {(pageAccessRights && pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => submitModifyClient()}>{translate('btnUpdate')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        }
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        client: state.remote.client
    };
};

export default connect(mapStateToProps, {
    actionGetVFASPClient
})(ClientModify);
